<div class="container">
    <div class="row">
        <div class="col-12">
    <div class="container">
        <h1>Integritetspolicy för Fototävling</h1>
        <p class="updated"><strong>Senast uppdaterad:</strong> 1 oktober 2025</p>

        <div class="highlight">
            <p><strong>Sammanfattning:</strong> Vi samlar endast in ditt namn och e-postadress från Facebook för att du ska kunna använda tjänsten. Vi säljer aldrig dina uppgifter.</p>
        </div>

        <h2>1. Vilka uppgifter samlar vi in?</h2>
        <p>Vi samlar endast in:</p>
        <ul>
            <li>Ditt namn</li>
            <li>Din e-postadress</li>
        </ul>
        <p>Denna information hämtas från ditt Facebook-konto när du loggar in.</p>

        <h2>2. Varför samlar vi in dina uppgifter?</h2>
        <p>Vi använder dina uppgifter för att:</p>
        <ul>
            <li>Identifiera dig i applikationen</li>
            <li>Visa ditt namn i tävlingar</li>
            <li>Kontakta dig vid behov angående tävlingar</li>
        </ul>

        <h2>3. Vem delar vi dina uppgifter med?</h2>
        <p>Ditt namn är synligt för andra användare i tävlingar du deltar i. Vi delar aldrig din e-postadress med andra användare och vi säljer aldrig dina uppgifter till tredje part.</p>

        <h2>4. Dina rättigheter</h2>
        <p>Du har rätt att:</p>
        <ul>
            <li>Få tillgång till dina uppgifter</li>
            <li>Rätta felaktiga uppgifter</li>
            <li>Radera dina uppgifter</li>
            <li>Få dina uppgifter i ett strukturerat format</li>
        </ul>
        <p>Kontakta oss på <strong>erik at kvarnbrannaby punkt se</strong> för att utöva dina rättigheter.</p>

        <h2>5. Säkerhet</h2>
        <p>Vi skyddar dina uppgifter med krypterad dataöverföring (HTTPS) och säkra servrar.</p>

        <h2>6. Cookies</h2>
        <p>Vi använder cookies för att hålla dig inloggad. Du kan blockera cookies i din webbläsare, men då fungerar inte inloggningen.</p>

        <h2>7. Ändringar</h2>
        <p>Vi kan uppdatera denna policy. Fortsatt användning efter ändringar innebär att du accepterar dem.</p>

        <h2>8. Kontakt</h2>
        <div class="contact">
            <p><strong>Personuppgiftsansvarig:</strong> Fototävling<br>
            <strong>E-post:</strong> erik at kvarnbrannaby punkt se</p>
        </div>

        <h2>9. Klagomål</h2>
        <p>Vid klagomål kan du kontakta Integritetsskyddsmyndigheten (IMY) på www.imy.se</p>

        <div class="footer">
            <p>Genom att använda Fototävling godkänner du denna integritetspolicy.</p>
        </div>
    </div>
        </div>
    </div>
</div>